import { mapEnumToOptions } from '@abp/ng.core';

export enum TicketStatus {
  New = 0,
  InProgress = 1,
  Done = 2,
}

export const ticketStatusOptions = mapEnumToOptions(TicketStatus);
